export const T = {
  en_GB: {
    showingResults: (p: { from: string; to: string; total: string }) =>
      `Showing ${p.from}-${p.to} of ${p.total} results`,
    previous: "Previous",
    next: "Next",
    pageOf: (page: string, totalPages: string) => `Page ${page} of ${totalPages}`,
  },
  nb_NO: {
    showingResults: (p: { from: string; to: string; total: string }) =>
      `Viser ${p.from}-${p.to} av ${p.total} resultater`,
    previous: "Forrige",
    next: "Neste",
    pageOf: (page: string, totalPages: string) => `Side ${page} av ${totalPages}`,
  },
} as const;
